import type {TicketingListItemData} from './types';

import {dateToReadableDate} from '@date-picker';
import {Badge, Chip} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import {TicketState} from 'utils/constant';

type TicketingListItemProps = {
  item: TicketingListItemData;
  onClick: () => void;
};

const TicketingListItem: React.FC<TicketingListItemProps> = ({item, onClick}) => {
  const chipProps = getStatusChipProps(item.state);

  return (
    <button
      type="button"
      className="flex w-full cursor-pointer items-center justify-between gap-4 border-0 border-b border-gray-03 bg-white px-4 py-3 text-start"
      onClick={onClick}
    >
      <span className="flex min-w-0 flex-col gap-1">
        <span className="truncate text-body-sm-emphasis text-neutral-fg">{item.tag_title}</span>
        {item.order_code ? (
          <span className="truncate text-body-xs text-gray-07">
            کد سفارش:
            <Badge color="primary" size="sm">
              {item.order_code}
            </Badge>
          </span>
        ) : null}
        <time className="text-body-xs text-gray-07">
          {dateToReadableDate({
            date: item.created_at,
            year: true,
            month: true,
            day: true
          })}
        </time>
      </span>

      <Chip
        label={TicketState[item.state as keyof typeof TicketState] ?? item.state}
        variant={chipProps.variant}
        color={chipProps.color}
        size="sm"
        interactive={false}
      />
    </button>
  );
};

export default TicketingListItem;
